import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23743810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-drawer background-fb" }
const _hoisted_2 = { class: "card-header header-drawer loop-drawer-header d-flex flex-row align-items-center justify-content-between" }
const _hoisted_3 = { class: "loop-drawer-title" }
const _hoisted_4 = { class: "loop-drawer-title__icon" }
const _hoisted_5 = { class: "loop-drawer-actions d-flex align-items-center justify-content-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  class: "card-body loop-settings-body overflow-auto",
  id: "routes"
}
const _hoisted_8 = { class: "loop-settings-form" }
const _hoisted_9 = { class: "loop-form-field" }
const _hoisted_10 = { class: "loop-desc" }
const _hoisted_11 = {
  key: 0,
  class: "loop-form-field"
}
const _hoisted_12 = { class: "loop-desc" }
const _hoisted_13 = {
  key: 1,
  class: "loop-form-field"
}
const _hoisted_14 = { class: "loop-desc" }
const _hoisted_15 = {
  key: 2,
  class: "loop-form-field"
}
const _hoisted_16 = { class: "loop-desc" }
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 3,
  class: "loop-form-field"
}
const _hoisted_20 = {
  class: "loop-desc",
  for: "batchSize-input"
}
const _hoisted_21 = {
  key: 4,
  class: "loop-form-field"
}
const _hoisted_22 = ["id"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["aria-labelledby", "value", "contenteditable"]
const _hoisted_25 = {
  key: 5,
  class: "loop-parallel-settings"
}
const _hoisted_26 = { class: "loop-parallel-row" }
const _hoisted_27 = { class: "loop-parallel-label" }
const _hoisted_28 = { class: "loop-desc" }
const _hoisted_29 = { class: "loop-worker-row" }
const _hoisted_30 = {
  class: "loop-desc",
  for: "threadCount-input"
}
const _hoisted_31 = { class: "loader-div-sm" }
const _hoisted_32 = ["src", "alt"]

import {
  computed,
  inject,
  ref,
  watch,
  onMounted,
  onUnmounted,
  defineAsyncComponent,
  nextTick,
} from "vue";
import {
  ElScrollbar,
  ElSelect,
  ElOption,
  ElTooltip,
  ElTag,
  ElCheckbox,
  ElInputNumber,
} from "element-plus";
import i18n from "@/core/i18n/i18n";
import { DEFAULT_LOGO, ASSETS_BASE_URL, getResolution } from "@/core/logo";
import { getParameter } from "@/core/util";
import JsonTreeView from "@/flow/components/json-tree-view/JsonTreeView.vue";
import { showAlert } from "@/core/popup";
import { currentRoute } from "@/core/router";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";
import { TYPE } from "vue-toastification";
import { isEmpty } from "lodash-es";
import {
  getCaretPosition,
  setCaretPosition,
  saveCaretPosition,
  ensureCaretRestored,
  copyContainerContent,
  handlePastedHtml,
  isOurSpanHtml,
  handleBackspaceZWSP,
} from "@/core/json-forms/components/service";
import {
  addOutput as commonAddOutput,
  addMetaoutput as commonAddMetaoutput,
  addUserVariable as commonAddUserVariable,
  addSystemVariable as commonAddSystemVariable,
  addFunction as commonAddFunction,
} from "@/core/json-forms/components/spanInjection";
import { useStepDisplay } from "@/core/composables/useStepDisplay";
import { useActivity } from "../application/activity";
import {
  connectWebsocket,
  getFlowActiveValue,
  simulateStep,
} from "../services/flow.service";
import { getTooltipForMetaoutput } from "../application/useTooltipForTags";
import {
  normalizeMetaoutputReference,
  normalizeOutputReference,
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
} from "../utils/outputReferenceUtils";
import {
  DEFAULT_BATCH_SIZE,
  DEFAULT_FOR_LOOP_COUNT,
  DEFAULT_LOOP_THREAD_COUNT,
  DEFAULT_LOOP_TYPE,
  LOOP_TYPE_OPTIONS,
  getDefaultLoopConfig,
  hasParallelProcessingAncestorLoop,
  hasParallelProcessingDescendantLoop,
  isConditionalLoopType,
  isParallelProcessingLoopType,
  normalizeLoopConfig,
  normalizeLoopType,
  shouldClearLoopPredicate,
} from "../utils/loopUtils";
import type { LoopConfig, LoopType } from "../utils/loopUtils";
import { isParallelProcessingEnabled } from "../services/parallelProcessing.service";

const LOOP_VARIABLE_INPUT_ID = "loopVariable-input";
const COUNT_INPUT_ID = "count-input";
const CONDITIONAL_LOOP_VALUE = "CONDITIONAL";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditLoop',
  props: {
    step: {},
    size: {},
    stepIndex: {},
    outputList: {},
    stepSimulating: {},
    metaoutputList: {},
    userDefinedVariables: {},
    systemVariables: {},
    disabled: { type: Boolean },
    placeholder: {},
    modelValue: {},
    expressions: {},
    stepList: {},
    wizardEnabled: { type: Boolean }
  },
  emits: [
  "close",
  "on-change",
  "closeDrawer",
  "updateSimulate",
  "updateOutput",
  "update:modelValue",
  "change",
  "changeFunctionVisible",
  "analyze-with-wizard",
  // OT-4718 (Step 6): WHILE/DO_WHILE predicate edits — saved to the LOOP step's `filter` by the parent.
  "predicate-change",
  "predicate-changes-happened",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const FunctionSelector = defineAsyncComponent(
  () => import("@/core/json-forms/components/FunctionSelector.vue")
);
// OT-4718 (Step 6): the WHILE/DO_WHILE predicate reuses the ROUTER condition editor; it persists to the
// LOOP step's `filter` field (the same FilterDto[] shape routers use).
const Condition = defineAsyncComponent(
  () => import("@/flow/components/Condition.vue")
);

const { t } = i18n.global;
const { getStepDisplayNumber } = useStepDisplay();
const preferOrigIdOutputReferences = inject(
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  true
);

const emit = __emit;

const props = __props;
const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);
const OutputDataDialog = defineAsyncComponent(
  () => import("@/flow/components/OutputDataDialog.vue")
);
const simulateDialogVisible = ref(false);
const simulateButtonVisibility = ref(false);
const simulating = ref(false);
const outputMap = new Map();
const selectedBuffer = ref([]);
const outputBuffer = ref([]);
const activityId = ref("");
const selectedOutputId = ref(null);
const selectedMetaoutputId = ref();
const scrollbar: any = ref();
const loading = ref(false);
const output = ref("");
const keyList = ref([]);
const initValue = ref(0);
const contextPath = ref("");
const outputData = ref();
const dialogVisible = ref(false);
const outputDataList = ref([]);
const checkFailedContentData = ref({
  numberOfTime: 0,
  logLength: 0,
  hasFailed: false,
  checkOfTime: 0,
});
const LOOP_VARIABLE_DIV_ID = `${LOOP_VARIABLE_INPUT_ID}-0-div-`;
const COUNT_DIV_ID = `${COUNT_INPUT_ID}-0-div-`;
const selectedLoopType = ref<LoopType>(DEFAULT_LOOP_TYPE);
// OT-4718 (Step 6): WHILE and DO_WHILE are shown as one "Repeat while condition is true" option in the
// loop-type dropdown (value CONDITIONAL_LOOP_VALUE); a sub-dropdown (conditionMode) picks WHILE vs
// DO_WHILE, which is what actually persists to step.loopType. selectedLoopType stays the real loopType.
const conditionMode = ref<"WHILE" | "DO_WHILE">("WHILE");
const loopVariable = ref("");
const count = ref(DEFAULT_FOR_LOOP_COUNT);
const parallelProcessing = ref(false);
const parallelProcessingFeatureEnabled = ref(false);
const threadCountInput = ref<number>(DEFAULT_LOOP_THREAD_COUNT);
// OT-4718 Step 7 — BATCH group size N (loop_config.batchSize). Only meaningful for BATCH loops.
const batchSizeInput = ref<number>(DEFAULT_BATCH_SIZE);
const functionSelectorVisible = ref(false);
const idCount = ref(0);
const focusId = ref("");
const focusIx = ref(-1);
let client: any | null = null;
let activitySub: any | null = null;
let logCheckInterval: ReturnType<typeof setInterval> | null = null;
const hoveredField = ref<string>("");
const recentlyCopied = ref<string>("");

const selectedOutput: any = computed(() => {
  if (selectedOutputId.value !== undefined) {
    return props.outputList.find(
      (item: any) => item.index === selectedOutputId.value
    );
  }
  return null;
});
const disableSimulateButton = computed(() =>
  simulateDialogVisible.value
    ? simulating.value ||
      typeof props.step.id !== "string" ||
      props.step.id.includes("new") ||
      simulateDialogVisible.value ||
      props.stepSimulating
    : simulateDialogVisible.value || props.stepSimulating
);
const flowId = computed(() => currentRoute.value.params.id as string);
const flowVersion = computed(() => currentRoute.value.params.version as string);

// The loop-type dropdown options, with WHILE + DO_WHILE collapsed into one "conditional" row (the
// WHILE/DO_WHILE choice moves to a sub-dropdown). Other loop types map through unchanged.
const loopOptions = computed<
  Array<{ label: string; value: string; enabled: boolean }>
>(() => {
  const merged: Array<{ label: string; value: string; enabled: boolean }> = [];
  let conditionalAdded = false;
  LOOP_TYPE_OPTIONS.forEach(({ value, labelKey, enabled }) => {
    if (isConditionalLoopType(value)) {
      if (!conditionalAdded) {
        merged.push({
          value: CONDITIONAL_LOOP_VALUE,
          label: t("Common.LoopOptionConditional"),
          enabled: LOOP_TYPE_OPTIONS.some(
            (opt) => isConditionalLoopType(opt.value) && opt.enabled
          ),
        });
        conditionalAdded = true;
      }
      return;
    }
    merged.push({ label: t(labelKey), value, enabled });
  });
  return merged;
});

// What the loop-type dropdown shows: the "conditional" row for WHILE/DO_WHILE, else the real loop type.
const displayLoopType = computed(() =>
  isConditionalLoopType(selectedLoopType.value)
    ? CONDITIONAL_LOOP_VALUE
    : selectedLoopType.value
);

const supportsParallelProcessing = computed(() =>
  isParallelProcessingLoopType(selectedLoopType.value)
);
const hasParallelProcessingAncestor = computed(() =>
  hasParallelProcessingAncestorLoop(props.step, props.stepList ?? [])
);
const hasParallelProcessingDescendant = computed(() =>
  hasParallelProcessingDescendantLoop(props.stepList ?? [], props.step?.origId)
);
const showParallelProcessingSettings = computed(
  () =>
    parallelProcessingFeatureEnabled.value &&
    supportsParallelProcessing.value &&
    !hasParallelProcessingAncestor.value
);
const parallelProcessingCheckboxDisabled = computed(() => props.disabled);
const threadCountDisabled = computed(
  () => props.disabled || !parallelProcessing.value
);
const isCountInputFocused = computed(() =>
  focusId.value.startsWith(COUNT_INPUT_ID)
);

// OT-4718 (Step 6): WHILE / DO_WHILE are predicate-driven — they hide the "iterate over" source and show
// the Predicate (condition) editor instead.
const isConditionalLoop = computed(() =>
  isConditionalLoopType(selectedLoopType.value)
);
// Single embedded Condition instance — active whenever its inputs are focused (drives its FunctionSelector).
const predicateActive = ref(false);

// The outputs/metaoutputs the predicate may reference — the same availableOutput filtering the standalone
// step filter uses, so the loop predicate offers exactly the in-scope prior-step outputs.
const predicateOutputList = computed(() => {
  const list = Array.isArray(props.outputList) ? props.outputList : [];
  const available = props.step?.availableOutput;
  if (!Array.isArray(available)) return list;
  return list.filter(
    (item: any) =>
      available.some((x: any) => x.uniqueId === item.uniqueId) ||
      props.step?.uniqueId === item.uniqueId
  );
});
const predicateMetaoutputList = computed(() => {
  const list = Array.isArray(props.metaoutputList) ? props.metaoutputList : [];
  const available = props.step?.availableMetaoutput;
  if (!Array.isArray(available)) return list;
  return list.filter(
    (item: any) =>
      available.some((x: any) => x.uniqueId === item.uniqueId) ||
      props.step?.uniqueId === item.uniqueId
  );
});

function onPredicateChange(filter: any): void {
  emit("predicate-change", filter);
}
function onPredicateChangesHappened(): void {
  emit("predicate-changes-happened");
}
function onPredicateFunctionsVisible(visible: boolean): void {
  // Reuse the existing FunctionSelector-visibility channel the parent already listens on.
  emit("changeFunctionVisible", visible);
}

function emitLoopChange(): void {
  if (!props.step?.id) return;
  if (props.step?.type !== "LOOP") return;

  emit(
    "on-change",
    selectedOutputId.value,
    loopVariable.value,
    props.step.id,
    selectedLoopType.value,
    getCurrentLoopConfig()
  );
}

function onLoopTypeChange(value: LoopType): void {
  const previousLoopType = selectedLoopType.value;
  selectedLoopType.value = normalizeLoopType(value);
  enforceParallelProcessingRules();
  // A loop type with no condition (SPLIT/FOR/BATCH) must not keep a leftover predicate on the step. The
  // clear is keyed on the loop-type transition, not props.step.filter — see shouldClearLoopPredicate.
  if (shouldClearLoopPredicate(previousLoopType, selectedLoopType.value)) {
    emit("predicate-change", []);
    emit("predicate-changes-happened");
  }
  emitLoopChange();
  hydrateSelectedLoopInput();
}

// The loop-type dropdown emits the merged "conditional" value for WHILE/DO_WHILE; resolve it to the
// current condition mode (defaulting to WHILE when entering a conditional loop from another type).
function onDisplayLoopTypeChange(displayValue: string): void {
  if (displayValue === CONDITIONAL_LOOP_VALUE) {
    if (!isConditionalLoopType(selectedLoopType.value)) {
      conditionMode.value = "WHILE";
    }
    onLoopTypeChange(conditionMode.value);
    return;
  }
  onLoopTypeChange(displayValue as LoopType);
}

// The WHILE vs DO_WHILE sub-dropdown — this is what actually sets the persisted loopType.
function onConditionModeChange(mode: "WHILE" | "DO_WHILE"): void {
  conditionMode.value = mode;
  onLoopTypeChange(mode);
}

async function hydrateSelectedLoopInput(): Promise<void> {
  await nextTick();

  if (selectedLoopType.value === "FOR") {
    const countEl = document.getElementById(COUNT_DIV_ID);
    if (countEl && countEl.childNodes.length === 0) {
      await addToDiv(count.value, COUNT_INPUT_ID, 0);
    }
    return;
  }

  const loopVariableEl = document.getElementById(LOOP_VARIABLE_DIV_ID);
  if (
    loopVariableEl &&
    loopVariableEl.childNodes.length === 0 &&
    loopVariable.value
  ) {
    await addToDiv(loopVariable.value, LOOP_VARIABLE_INPUT_ID, 0);
  }
}

function sanitizeThreadCount(value: unknown): number {
  const parsed =
    typeof value === "number" ? value : parseInt(String(value ?? ""), 10);

  if (!Number.isFinite(parsed) || parsed < 1) {
    return 1;
  }

  return Math.floor(parsed);
}

// OT-4718 Step 7 — a batch size is a positive integer (>= 1), same coercion as the thread count.
function sanitizeBatchSize(value: unknown): number {
  const parsed =
    typeof value === "number" ? value : parseInt(String(value ?? ""), 10);

  if (!Number.isFinite(parsed) || parsed < 1) {
    return DEFAULT_BATCH_SIZE;
  }

  return Math.floor(parsed);
}

function getCurrentLoopConfig(): LoopConfig {
  if (selectedLoopType.value === "FOR") {
    return { count: count.value };
  }

  const config: LoopConfig =
    supportsParallelProcessing.value && parallelProcessing.value
      ? {
          parallelProcessing: true,
          threadCount: sanitizeThreadCount(threadCountInput.value),
        }
      : getDefaultLoopConfig();

  // OT-4718 Step 7 — BATCH always carries its group size N alongside the (possibly default) parallel
  // settings. SPLIT never gets a batchSize.
  if (selectedLoopType.value === "BATCH") {
    config.batchSize = sanitizeBatchSize(batchSizeInput.value);
  }

  return config;
}

function isCurrentLoopConfigPersisted(): boolean {
  const config = normalizeLoopConfig(
    props.step?.loopConfig,
    selectedLoopType.value
  );
  const current = getCurrentLoopConfig();

  if (selectedLoopType.value === "FOR") {
    return config.count === current.count;
  }

  if (
    selectedLoopType.value === "BATCH" &&
    config.batchSize !== current.batchSize
  ) {
    return false;
  }

  return (
    config.parallelProcessing === current.parallelProcessing &&
    config.threadCount === current.threadCount
  );
}

function applyLoopConfig(loopConfig: any): void {
  const normalized = normalizeLoopConfig(loopConfig, selectedLoopType.value);

  if (selectedLoopType.value === "FOR") {
    count.value = normalized.count ?? DEFAULT_FOR_LOOP_COUNT;
    parallelProcessing.value = false;
    threadCountInput.value = DEFAULT_LOOP_THREAD_COUNT;
    return;
  }

  parallelProcessing.value = normalized.parallelProcessing ?? false;
  threadCountInput.value = sanitizeThreadCount(normalized.threadCount);
  // OT-4718 Step 7 — restore the persisted BATCH group size (defaults to DEFAULT_BATCH_SIZE for a fresh
  // BATCH loop or any non-BATCH type, where normalized.batchSize is undefined).
  batchSizeInput.value = sanitizeBatchSize(normalized.batchSize);
  enforceParallelProcessingRules();
}

function enforceParallelProcessingRules(): boolean {
  if (supportsParallelProcessing.value) {
    return false;
  }

  const changed =
    parallelProcessing.value ||
    sanitizeThreadCount(threadCountInput.value) !== DEFAULT_LOOP_THREAD_COUNT;

  parallelProcessing.value = false;
  threadCountInput.value = DEFAULT_LOOP_THREAD_COUNT;

  return changed;
}

function onParallelProcessingChange(value: unknown): void {
  if (parallelProcessingCheckboxDisabled.value) return;

  const nextValue = Boolean(value);
  if (nextValue && hasParallelProcessingDescendant.value) {
    parallelProcessing.value = false;
    threadCountInput.value = DEFAULT_LOOP_THREAD_COUNT;
    showAlert(TYPE.WARNING, t("Common.ParallelJobsDescendantWarning"));
    return;
  }

  parallelProcessing.value = nextValue;
  if (!parallelProcessing.value) {
    threadCountInput.value = DEFAULT_LOOP_THREAD_COUNT;
  }

  emitLoopChange();
}

watch(
  () => [supportsParallelProcessing.value, hasParallelProcessingAncestor.value],
  () => {
    if (enforceParallelProcessingRules()) {
      emitLoopChange();
    }
  }
);

const computedId = computed(() => {
  if (focusId.value) {
    return `${focusId.value}-div-`;
  }
  return "";
});

function rebuildOutputDataList() {
  const list = Array.isArray(props.outputList) ? props.outputList : [];

  const filtered = props?.step?.availableOutput
    ? list.filter((item: any) =>
        props.step.availableOutput.some(
          (subItem: any) => item.uniqueId === subItem.uniqueId
        )
      )
    : [];

  outputDataList.value = filtered;
}

watch(
  () => selectedOutput.value,
  () => {
    if (selectedOutput.value) {
      output.value = "";
      initValue.value = 0;
      convertToLazyLoad();
    }
  }
);
watch(
  () => [props.outputList, props.step?.availableOutput],
  () => {
    rebuildOutputDataList();

    if (props.step?.output) {
      let convertedOutput;
      try {
        convertedOutput = JSON.stringify(JSON.parse(props.step?.output));
        outputData.value = convertedOutput;
      } catch (e) {
        outputData.value = JSON.stringify({
          output: { "invalid output": "invalid output" },
        });
        console.log("invalid json");
      }
    }

    if (functionSelectorVisible.value && outputDataList.value.length === 0) {
      functionSelectorVisible.value = false;
      emit("changeFunctionVisible", false);
    }
  },
  { deep: true, immediate: true }
);
watch(
  () => simulating.value,
  () => {
    emit("updateSimulate", simulating.value);
  }
);

const dropdownWidth = computed(() => {
  switch (props.size) {
    case 0:
      return "468px";
    case 1:
      return "768px";
    case 2:
      return "1068px";
    default:
      return "768px";
  }
});

function closeSimulateDialog() {
  simulateDialogVisible.value = false;
}

// Bubble up to EditVueFlow.vue, which owns the WizardDrawer instance.
function handleAnalyzeWithWizard(activityIdToAnalyze: string) {
  simulateDialogVisible.value = false;
  emit("analyze-with-wizard", activityIdToAnalyze);
}

function disableOutputButton() {
  return simulateDialogVisible.value
    ? isEmpty(outputData.value) || simulateDialogVisible.value
    : simulateDialogVisible.value;
}

function closeOutputDataDialog() {
  dialogVisible.value = false;
}

function openOutputDialog() {
  dialogVisible.value = true;
}

function onThreadCountInput(value: number | undefined | null): void {
  threadCountInput.value = sanitizeThreadCount(value);
  emitLoopChange();
}

function onBatchSizeInput(value: number | undefined | null): void {
  batchSizeInput.value = sanitizeBatchSize(value);
  emitLoopChange();
}

// Shared digit-only guards for the numeric loop inputs (Thread Count and Batch Size): block any keystroke
// or paste that would produce a non-positive-integer value.
function onPositiveIntegerKeyDown(event: KeyboardEvent): void {
  const allowedControlKeys = new Set([
    "Backspace",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
  ]);

  if (allowedControlKeys.has(event.key)) return;

  if (
    (event.ctrlKey || event.metaKey) &&
    ["a", "c", "v", "x", "z"].includes(event.key.toLowerCase())
  ) {
    return;
  }

  if (/^\d$/.test(event.key)) {
    const input = event.target as HTMLInputElement | null;
    const currentValue = input?.value ?? "";
    const selectionStart = input?.selectionStart ?? currentValue.length;
    const selectionEnd = input?.selectionEnd ?? currentValue.length;
    const nextValue = `${currentValue.slice(0, selectionStart)}${
      event.key
    }${currentValue.slice(selectionEnd)}`;

    if (/^[1-9]\d*$/.test(nextValue.trim())) return;
  }

  event.preventDefault();
}

function onPositiveIntegerPaste(event: ClipboardEvent): void {
  const pastedText = event.clipboardData?.getData("text/plain") ?? "";

  if (!/^[1-9]\d*$/.test(pastedText.trim())) {
    event.preventDefault();
  }
}

function syncThreadCountInputFromDom(): void {
  const threadCountEl = document.querySelector<HTMLInputElement>(
    "#threadCount-input input"
  );
  if (!threadCountEl) return;

  threadCountInput.value = sanitizeThreadCount(threadCountEl.value);
  threadCountEl.value = String(threadCountInput.value);
}

function syncBatchSizeInputFromDom(): void {
  const batchSizeEl = document.querySelector<HTMLInputElement>(
    "#batchSize-input input"
  );
  if (!batchSizeEl) return;

  batchSizeInput.value = sanitizeBatchSize(batchSizeEl.value);
  batchSizeEl.value = String(batchSizeInput.value);
}

function setFocusInput(index, id) {
  console.log("EditLoop setFocusInput");

  rebuildOutputDataList();

  if (outputDataList.value.length === 0 && id !== COUNT_INPUT_ID) {
    functionSelectorVisible.value = false;
    emit("changeFunctionVisible", false);
    // showAlert(TYPE.INFO, t("Flow.NoAvailableOutputForLoop"));
    return;
  }

  focusId.value = `${id}-${index}`;
  // focusInputId.value = index;
  functionSelectorVisible.value = true;
  emit("changeFunctionVisible", true);
}

async function simulate(bypassConditions) {
  simulateButtonVisibility.value = true;
  if (logCheckInterval) {
    clearInterval(logCheckInterval);
    logCheckInterval = null;
  }
  if (activitySub) {
    if (typeof activitySub.unsubscribe === "function") {
      activitySub.unsubscribe();
    }
    activitySub = null;
  }
  if (client) {
    client.disconnect();
    client = null;
  }
  const flowActive = await getFlowActiveValue(flowId.value, flowVersion.value);
  if (flowActive) {
    try {
      selectedBuffer.value = [];
      outputBuffer.value = [];
      outputMap.clear();
      const stepId = props.step?.id;

      if (
        typeof props.step.id === "string" &&
        !props.step.id.includes("new") &&
        flowId.value
      ) {
        simulating.value = true;
        activityId.value = await simulateStep(
          stepId,
          flowId.value,
          flowVersion.value,
          bypassConditions
        );
        const { checkIsRunActivityFromSocket } = useActivity();
        connectWebsocket()
          .then((stompClient) => {
            stompClient.debug = (f) => f;
            client = stompClient;
            stompClient.connect({}, async () => {
              simulateDialogVisible.value = true;
              outputMap.set(flowId, outputBuffer.value);
              selectedBuffer.value = outputBuffer.value;
              // Since the initialization message added for simulation in the gateway could not be displayed in the process logs,
              // the message is added to the buffer in the UI within the scope of OT-2382 ticket.
              outputBuffer.value.push(
                `${t("Flow.SimulationInitialLog")} ${props.step.flow.name}`
              );
              activitySub = stompClient.subscribe(
                WebsocketUrlProvider.ActivityProgress(activityId.value),
                (val) => {
                  outputBuffer.value.push(val.body);
                  checkFailedContentData.value.hasFailed =
                    val.body.includes("Failed");
                }
              );
              /* Check Data */
              if (simulating.value) {
                const checkOfTime = parseInt(
                  await getParameter("FLOW_PROCESS_LOG_CHECKS_INTERVAL"),
                  10
                );
                const numberOfTime = parseInt(
                  await getParameter("FLOW_LOG_CHECKS_TOTAL"),
                  10
                );
                const timeout = parseInt(
                  await getParameter("FLOW_PROCESS_LOG_CHECKS_TIMEOUT"),
                  10
                );
                logCheckInterval = setInterval(() => {
                  checkFailedContentData.value = {
                    ...checkFailedContentData.value,
                    checkOfTime:
                      outputBuffer.value.length ===
                      checkFailedContentData.value.logLength
                        ? checkFailedContentData.value.checkOfTime + 1
                        : checkFailedContentData.value.checkOfTime,
                    logLength: outputBuffer.value.length,
                    numberOfTime: checkFailedContentData.value.numberOfTime + 1,
                  };
                  if (
                    checkFailedContentData.value.checkOfTime > checkOfTime ||
                    checkFailedContentData.value.numberOfTime > numberOfTime
                  ) {
                    simulating.value = false;
                    if (logCheckInterval) {
                      clearInterval(logCheckInterval);
                      logCheckInterval = null;
                    }
                    checkFailedContentData.value = {
                      numberOfTime: 0,
                      logLength: 0,
                      hasFailed: false,
                      checkOfTime: 0,
                    };
                  }
                }, timeout);
              }
              simulating.value = await checkIsRunActivityFromSocket(
                stompClient,
                activityId.value
              );
              emit("updateOutput");
            });
          })
          .catch(() => {
            console.log("catch");
          });
      }
    } catch (e) {
      simulating.value = false;
      showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
    }
  } else {
    showAlert(TYPE.ERROR, t("Flow.InactiveStep"));
  }
  simulateButtonVisibility.value = false;
}

function isValidOutput(step): boolean {
  try {
    JSON.stringify(JSON.parse(step.output));
    return true;
  } catch (e) {
    return false;
  }
}

function convertToLazyLoad() {
  if (selectedOutput.value) {
    output.value = parseOutputValue(selectedOutput.value.output);
  }
  initValue.value += 30;
}

function parseOutputValue(outputValue) {
  try {
    let outputValueString = outputValue;

    // Encapsulating numeric values inside double quotes just for UI representation.
    outputValueString = outputValueString.replace(
      /(?<=:\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\s])/g,
      (match) => `"${match}"`
    );
    outputValueString = outputValueString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    outputValueString = outputValueString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    const json = JSON.parse(outputValueString);
    const obj = {};
    keyList.value = Object.keys(json);

    keyList.value
      .slice(initValue.value, initValue.value + 30)
      .forEach((key) => {
        obj[key] = json[key];
      });

    return JSON.stringify(obj);
  } catch (error) {
    return outputValue;
  }
}

function addOutput(params, first, isNotFirstRender = true) {
  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = commonAddOutput(
      params,
      outputDataList.value,
      idCount.value,
      isNotFirstRender
    );
    idCount.value++;
    addItemToInput(span, first);
  }
}

function addMetaoutput(params, first, isNotFirstRender = true) {
  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = commonAddMetaoutput(
      {
        name: params.name,
        path: params.path,
        stepIndex: params.stepIndex,
        stepNumber: params.stepNumber,
        origId: params.origId,
      },
      props.metaoutputList,
      idCount.value,
      isNotFirstRender
    );
    idCount.value++;
    addItemToInput(span, first);
  }
}
function serializeEditableToInputString(
  divId: string,
  fallbackValue: unknown = "[]"
): string {
  const el = document.getElementById(divId);
  if (!el) return String(fallbackValue || "[]");

  const inputArray: any[] = [];

  el.childNodes.forEach((child: any) => {
    if (child instanceof HTMLBRElement) {
      inputArray.push({ name: "\n", type: "input", function: "" });
      return;
    }

    if (child.nodeType === Node.ELEMENT_NODE) {
      const name = child.getAttribute("name");
      const type = child.getAttribute("type");
      if (name !== null && type !== null) {
        inputArray.push({
          name,
          origId: child.getAttribute("origId"),
          type,
          function: child.getAttribute("function"),
        });
      }
      return;
    }

    if (
      child.nodeType === Node.TEXT_NODE &&
      child.textContent !== "" &&
      child.textContent !== "\u200B"
    ) {
      inputArray.push({
        name: child.textContent.replaceAll("\u200B", ""),
        type: "input",
      });
    }
  });

  if (
    inputArray.length > 0 &&
    inputArray[inputArray.length - 1]?.name === "\n"
  ) {
    inputArray.pop();
  }

  return JSON.stringify(inputArray);
}

function updateCurrentSavedData() {
  try {
    const loopVariableEl = document.getElementById(LOOP_VARIABLE_DIV_ID);
    if (loopVariableEl) {
      loopVariable.value = serializeEditableToInputString(
        LOOP_VARIABLE_DIV_ID,
        loopVariable.value
      );
    }
    const countEl = document.getElementById(COUNT_DIV_ID);
    if (countEl) {
      count.value = serializeEditableToInputString(COUNT_DIV_ID, count.value);
    }

    syncThreadCountInputFromDom();
    syncBatchSizeInputFromDom();
    emitLoopChange();
  } catch (e) {
    console.log("updateCurrentSavedData error", e);
  }
}

__expose({ updateCurrentSavedData, simulate });

function addSystemVariable(params, first) {
  const span: HTMLSpanElement = commonAddSystemVariable(
    {
      name: params.name,
      path: params.name,
      stepIndex: 0,
      tooltip: params.tooltip,
    },
    params,
    idCount.value
  );
  idCount.value++;
  addItemToInput(span, first);
}

function addUserVariable(params, first) {
  if (!isCountInputFocused.value) return;

  const span: HTMLSpanElement = commonAddUserVariable(
    {
      name: params.name,
      path: params.path,
      stepIndex: 0,
      tooltip: params.tooltip,
    },
    props.userDefinedVariables,
    idCount.value,
    true
  );
  idCount.value++;
  addItemToInput(span, first);
}

function addFunction(params, first) {
  const spans = commonAddFunction(params, idCount.value);

  spans.forEach((span) => {
    addItemToInput(span, first);
  });

  idCount.value += spans.length;
  if (params.hasChild) {
    const mainSpan = spans[0];
    const zwsp = mainSpan.nextSibling;
    if (zwsp && zwsp.nodeType === Node.TEXT_NODE) {
      setCaretPosition(zwsp, computedId.value, 1);
    }
  }
}

const storedRange = ref<Range | null>(null);

function syncFocusedInputFromDom(): void {
  if (!computedId.value) return;

  const activeInput = document.getElementById(computedId.value);
  if (!activeInput) return;

  const targetValue = isCountInputFocused.value
    ? count.value
    : loopVariable.value;
  const serializedValue = serializeEditableToInputString(
    computedId.value,
    targetValue
  );

  if (isCountInputFocused.value) {
    count.value = serializedValue;
  } else {
    loopVariable.value = serializedValue;
  }
}

function onBlur(e: FocusEvent) {
  syncFocusedInputFromDom();

  if (functionSelectorVisible.value) {
    /* If the panel (e.g. FunctionSelector) is still open,
    only save the caret position—don’t clear focusIx/focusId. */
    storedRange.value = saveCaretPosition(e.target as Node);
    return;
  }
  // Panel is closed, so now clear our focus tracking:
  storedRange.value = saveCaretPosition(e.target as Node);
  focusId.value = "";
}

function getNextSibling(current?) {
  const elem = document.getElementById(computedId.value);
  const position = getCaretPosition(elem);
  let length = 0;
  let set = false;
  let childIndex = -1;
  elem.childNodes.forEach((child: any, index) => {
    if (child.nodeType === Node.TEXT_NODE) {
      length += child.data.length;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      length += child.innerText.length;
    }
    if (position <= length && !set && position !== 0) {
      childIndex = index;
      set = true;
    } else if (position === 0) {
      childIndex = -2;
      set = true;
    }
  });
  if (childIndex > -1) {
    return current
      ? {
          item: elem.childNodes.item(childIndex),
          index: childIndex,
        }
      : {
          item: elem.childNodes.item(childIndex + 1),
          index: childIndex + 1,
        };
  }
  if (childIndex === -2) {
    return {
      item: elem.childNodes.item(0),
      index: 0,
    };
  }
  return null;
}

function addItemToInput(span: HTMLSpanElement, first) {
  ensureCaretRestored(computedId.value, storedRange.value);
  const zeroWidthSpace = document.createTextNode("\u200B");
  const container = document.getElementById(computedId.value);
  const current: any = getNextSibling(true);
  const nextNode = getNextSibling();
  if (
    current &&
    current.item.nodeType === Node.TEXT_NODE &&
    current.item.data.length > 1 &&
    !first
  ) {
    const [firstText, second] = split(
      current.item.data,
      getCaretPosition(document.getElementById(computedId.value)) -
        getInputLengthToCaretPosition(current.index)
    );
    const firstElem = current.item;
    firstElem.data = firstText;
    document
      .getElementById(computedId.value)
      .replaceChild(firstElem, current.item);
    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(span, nextNode.item);
    } else {
      document.getElementById(computedId.value).appendChild(span);
    }

    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(document.createTextNode(second), nextNode.item);
    } else {
      document
        .getElementById(computedId.value)
        .appendChild(document.createTextNode(second));
    }
  } else {
    addToDocument(
      span,
      zeroWidthSpace,
      nextNode ? nextNode.item : undefined,
      first
    );
  }
  let trailingNode: Text;
  if (span.nextSibling && span.nextSibling.nodeType === Node.TEXT_NODE) {
    trailingNode = span.nextSibling as Text;
    if (
      trailingNode.textContent === "" ||
      trailingNode.textContent === "\u200B"
    ) {
      trailingNode.textContent = "\u200B";
      (trailingNode as any).dataset = { caretAnchor: "true" };
    }
  } else {
    trailingNode = document.createTextNode("\u200B");
    (trailingNode as any).dataset = { caretAnchor: "true" };
    container.insertBefore(trailingNode, span.nextSibling);
  }
  organizeNodes();
  setCaretPosition(span, computedId.value);

  if (container) {
    container.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function getInputLengthToCaretPosition(index) {
  let length = 0;
  document
    .getElementById(computedId.value)
    .childNodes.forEach((node: any, idx) => {
      if (node.nodeType === Node.TEXT_NODE && idx < index) {
        length += node.data.length;
      } else if (node.nodeType === Node.ELEMENT_NODE && idx < index) {
        length += node.innerText.length;
      }
    });
  return length;
}

function addToDocument(span, zero, next, first) {
  if (next && !first) {
    document.getElementById(computedId.value).insertBefore(span, next);
    document.getElementById(computedId.value).insertBefore(zero, span);
  } else {
    document.getElementById(computedId.value).appendChild(span);
    document.getElementById(computedId.value).appendChild(zero);
  }
}

function parseEditableElements(data, id) {
  try {
    const parsedElements = JSON.parse(data);
    return Array.isArray(parsedElements)
      ? parsedElements
      : [{ name: String(parsedElements), type: "input" }];
  } catch (error) {
    if (id === COUNT_INPUT_ID) {
      return data === undefined || data === null || data === ""
        ? []
        : [{ name: String(data), type: "input" }];
    }
    throw error;
  }
}

async function addToDiv(data, id, index) {
  focusId.value = `${id}-${index}`;
  focusIx.value = index;
  try {
    const elements = parseEditableElements(data, id);
    let newlineCount = false;
    elements.forEach((item) => {
      if (item.type === "input") {
        if (item.name === "\n") {
          newlineCount = true;
          addBrElement();
        } else {
          addText(item, computedId.value);
        }
      } else if (item.type === "output") {
        const normalizedOutput = normalizeOutputReference({
          name: item.name,
          origId: item.origId,
          outputList: props.outputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const arr = normalizedOutput.name.split("/#");
        const outputStepId =
          typeof normalizedOutput.index === "number"
            ? normalizedOutput.index
            : -1;
        selectedOutputId.value = outputStepId;
        addOutput(
          {
            name:
              outputStepId > -1 && arr.length >= 2
                ? `/${outputStepId}/#${arr[1]}`
                : normalizedOutput.name,
            path: outputStepId > -1 && arr.length >= 2 ? `/#${arr[1]}` : "",
            stepIndex: outputStepId,
            stepNumber:
              outputStepId > -1 ? normalizedOutput.stepNumber : undefined,
            origId: normalizedOutput.origId ?? item.origId,
          },
          true,
          false
        );
      } else if (item.type === "system-variable") {
        const systemVariables = {
          name: item.name,
          tooltip: props.systemVariables[item.name] || "",
        };
        addSystemVariable(systemVariables, true);
      } else if (item.type === "metaoutput") {
        const normalizedMetaoutput = normalizeMetaoutputReference({
          name: item.name,
          origId: item.origId,
          metaoutputList: props.metaoutputList,
          preferOrigId: preferOrigIdOutputReferences,
        });
        const arr = normalizedMetaoutput.name.split("/#");
        const metaoutputStepId =
          typeof normalizedMetaoutput.index === "number"
            ? normalizedMetaoutput.index
            : -1;
        const metaPath =
          arr.length >= 2 ? arr[1].split("@#").slice(1).join("@#") : "";
        selectedMetaoutputId.value = metaoutputStepId;
        const tooltip = getTooltipForMetaoutput(
          metaPath,
          metaoutputStepId,
          props.metaoutputList
        );
        addMetaoutput(
          {
            name:
              metaoutputStepId > -1 && metaPath
                ? `/${metaoutputStepId}/#${metaPath}`
                : normalizedMetaoutput.name,
            path: metaPath ? `/#${metaPath}` : "",
            stepIndex: metaoutputStepId,
            stepNumber:
              metaoutputStepId > -1
                ? normalizedMetaoutput.stepNumber
                : undefined,
            origId: normalizedMetaoutput.origId ?? item.origId,
            tooltip,
          },
          true,
          false
        );
      } else if (item.type === "user-defined-variable") {
        const arr = item.name.split("/#");
        const path = arr.length >= 2 ? `/#${arr[1]}` : item.name;
        addUserVariable({ name: path, path, tooltip: "" }, true);
      } else {
        const matchedExpression = props.expressions.find(
          (expression) => expression.name === item.name
        );
        const tooltip = matchedExpression?.description;
        const params = { ...item, tooltip };
        addFunction(params, true);
      }
    });
    if (newlineCount) {
      addBrElement();
    }
  } catch (e) {
    console.log(e);
  }
}
function addText(item, divId) {
  const text = document.createTextNode(item.name);
  document.getElementById(divId).appendChild(text);
}
function insertNewLine(div) {
  const br = document.createElement("br");
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);
  range.deleteContents();
  range.insertNode(br);
  range.setStartAfter(div.childNodes[div.childNodes.length - 1]);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
}
function addBrElement() {
  const br = document.createElement("br");
  document.getElementById(computedId.value).appendChild(br);
}
async function organizeNodes() {
  try {
    await nextTick();
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child, index) => {
        const nextChild = document
          .getElementById(computedId.value)
          .childNodes.item(index + 1);
        if (nextChild) {
          if (
            nextChild.nodeType === child.nodeType &&
            child.nodeType === Node.TEXT_NODE
          ) {
            const childText = child.textContent.trim();
            const nextText = nextChild.textContent.trim();
            const specialCharsRegex = /^[\u200B"']$/;
            if (
              specialCharsRegex.test(childText) ||
              specialCharsRegex.test(nextText)
            ) {
              return;
            }
            if (
              nextChild.textContent === "\u200B" ||
              child.textContent === "\u200B"
            ) {
              document
                .getElementById(computedId.value)
                .removeChild(
                  child.textContent !== "\u200B" ? nextChild : child
                );
            } else {
              child.textContent += nextChild.textContent;
              child.textContent = child.textContent.replace("\u200B", "");
              document.getElementById(computedId.value).removeChild(nextChild);
            }
          }
        }
      });
  } catch (e) {
    console.log(e, "organize");
  }
  convertToInputString();
}

function convertToInputString() {
  try {
    const inputArray = [];
    const activeInput = document.getElementById(computedId.value);
    if (!activeInput) return;

    activeInput.childNodes.forEach((child: any) => {
      if (child instanceof HTMLBRElement) {
        inputArray.push({
          name: Array(1).fill("\n").join(""),
          type: "input",
          function: "",
        });
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const name = child.getAttribute("name");
        const type = child.getAttribute("type");
        if (name !== null && type !== null) {
          inputArray.push({
            name: child.getAttribute("name"),
            origId: child.getAttribute("origId"),
            type: child.getAttribute("type"),
            function: child.getAttribute("function"),
          });
        }
      } else if (
        child.nodeType === Node.TEXT_NODE &&
        child.textContent !== "" &&
        child.textContent !== "\u200B"
      ) {
        inputArray.push({
          name: child.textContent.replaceAll("\u200B", ""),
          type: "input",
        });
      }
    });
    if (
      inputArray.length > 0 &&
      inputArray[inputArray.length - 1]?.name === "\n"
    ) {
      inputArray.pop();
    }
    const serializedValue = JSON.stringify(inputArray);
    if (isCountInputFocused.value) {
      count.value = serializedValue;
    } else {
      loopVariable.value = serializedValue;
    }
    emitLoopChange();
  } catch (e) {
    console.log(e, "string");
  }
}

function copyLoopContent() {
  copyInputContent(LOOP_VARIABLE_DIV_ID);
}

function copyInputContent(divId: string) {
  copyContainerContent(divId)
    .then(() => {
      recentlyCopied.value = divId;
      setTimeout(() => {
        if (recentlyCopied.value === divId) {
          recentlyCopied.value = "";
        }
      }, 2000);
    })
    .catch((err) => {
      console.error("Copy failed", err);
    });
}

function getAllowedPasteTypes(): string[] {
  if (!isCountInputFocused.value) return ["output"];

  const expressionTypes = Array.isArray(props.expressions)
    ? props.expressions
        .map((expression) => expression?.type)
        .filter((type): type is string => typeof type === "string")
    : [];

  return ["user-defined-variable", ...expressionTypes];
}

function pasteEvent(e: ClipboardEvent, index: number, id: string) {
  e.stopPropagation();
  e.preventDefault();
  setFocusInput(index, id);

  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData("text/plain");
  const html = clipboardData.getData("text/html");
  const range = document.getSelection().getRangeAt(0);

  if (isOurSpanHtml(html)) {
    handlePastedHtml(
      html,
      document.getElementById(computedId.value),
      range,
      props.outputList as any[],
      props.metaoutputList as any[],
      {
        preferOrigId: preferOrigIdOutputReferences,
        allowedTypes: getAllowedPasteTypes(),
      }
    );
    setTimeout(() => {
      organizeNodes();
    }, 100);
    return;
  }

  range.deleteContents();
  const textNode = document.createTextNode(pastedData);
  range.insertNode(textNode);
  range.selectNodeContents(textNode);
  range.collapse(false);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  setTimeout(() => {
    organizeNodes();
  }, 0);
  e.preventDefault();
}

function onKeyDown(event) {
  const div = document.getElementById(computedId.value);
  if (event.key === "Enter") {
    if (div.childNodes.length === 0) {
      addBrElement();
    } else if (div.childNodes.length === 1) {
      const node = div.childNodes[0];
      const isBr =
        node.nodeType === Node.ELEMENT_NODE &&
        node?.tagName?.toLowerCase() === "br";
      if (!isBr) {
        addBrElement();
      }
    }
    event.preventDefault();
    insertNewLine(div);
  } else if (event.key === "Backspace") {
    if (
      div.childNodes.length === 1 &&
      div.childNodes[0] instanceof HTMLBRElement
    ) {
      div.removeChild(div.childNodes[0]);
    }
    if (handleBackspaceZWSP(div, computedId.value)) {
      event.preventDefault();
    }
  }
}
function split(text, index) {
  return [text.slice(0, index), text.slice(index)];
}

function closeLoopDrawer() {
  emit("close");
}
onMounted(async () => {
  const parallelProcessingEnabledPromise = isParallelProcessingEnabled();

  if (functionSelectorVisible.value === false) {
    emit("changeFunctionVisible", false);
  }
  if (props.step && props.step.contentPath) {
    selectedOutputId.value = parseInt(
      props.step.contentPath.substring(1, 2),
      10
    );
  }
  const rawLoopType = props.step?.loopType;
  selectedLoopType.value = normalizeLoopType(rawLoopType);
  // Seed the condition-mode sub-dropdown from the persisted loop type (WHILE/DO_WHILE), else default.
  if (isConditionalLoopType(selectedLoopType.value)) {
    conditionMode.value = selectedLoopType.value as "WHILE" | "DO_WHILE";
  }
  applyLoopConfig(props.step?.loopConfig);
  if (props.step && props.step.contentPath) {
    loopVariable.value = props.step.contentPath;
  }
  await hydrateSelectedLoopInput();

  if (
    props.step?.type === "LOOP" &&
    (props.step?.loopType !== selectedLoopType.value ||
      !isCurrentLoopConfigPersisted())
  ) {
    emitLoopChange();
  }

  parallelProcessingFeatureEnabled.value =
    await parallelProcessingEnabledPromise;
  await nextTick();
});
onUnmounted(() => {
  if (logCheckInterval) {
    clearInterval(logCheckInterval);
    logCheckInterval = null;
  }

  if (activitySub) {
    if (typeof activitySub.unsubscribe === "function") {
      activitySub.unsubscribe();
    }
    activitySub = null;
  }

  if (client) {
    client.disconnect();
    client = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
        ]),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("Common.LoopSettings")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.step && _ctx.step.output)
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 0,
              effect: "custom",
              content: _unref(t)('Flow.OutputData')
            }, {
              default: _withCtx(() => [
                (_ctx.step.output)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link loop-icon-button",
                      id: "flow-output",
                      onClick: openOutputDialog,
                      disabled: disableOutputButton()
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "database" })
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link loop-icon-button",
          id: "filter-close",
          onClick: closeLoopDrawer
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "times" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("Common.LoopTypePrompt")), 1),
          _createVNode(_unref(ElSelect), {
            class: "loop-select",
            "model-value": displayLoopType.value,
            disabled: _ctx.disabled,
            placeholder: _ctx.placeholder || _unref(t)('Common.SelectLoopType'),
            filterable: "",
            size: "small",
            "aria-label": _unref(t)('Common.SelectLoopType'),
            onChange: onDisplayLoopTypeChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopOptions.value, (opt) => {
                return (_openBlock(), _createBlock(_unref(ElOption), {
                  key: opt.value,
                  label: opt.label,
                  value: opt.value,
                  disabled: !opt.enabled
                }, null, 8, ["label", "value", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["model-value", "disabled", "placeholder", "aria-label"])
        ]),
        (isConditionalLoop.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)("Common.LoopPredicatePrompt")), 1),
              _createVNode(_unref(Condition), {
                conditions: _ctx.step.filter || [],
                "output-list": predicateOutputList.value,
                "metaoutput-list": predicateMetaoutputList.value,
                "step-index": _ctx.stepIndex,
                "id-suffix": 'loop-predicate',
                "is-active": predicateActive.value,
                "user-defined-variables": _ctx.userDefinedVariables,
                "system-variables": _ctx.systemVariables,
                expressions: _ctx.expressions,
                onFocused: _cache[0] || (_cache[0] = ($event: any) => (predicateActive.value = true)),
                onOnChange: onPredicateChange,
                onChangesHappened: onPredicateChangesHappened,
                onChangeFunctionsVisible: onPredicateFunctionsVisible
              }, null, 8, ["conditions", "output-list", "metaoutput-list", "step-index", "is-active", "user-defined-variables", "system-variables", "expressions"])
            ]))
          : _createCommentVNode("", true),
        (isConditionalLoop.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)("Common.LoopConditionModePrompt")), 1),
              _createVNode(_unref(ElSelect), {
                class: "loop-select loop-condition-mode-select",
                "model-value": conditionMode.value,
                disabled: _ctx.disabled,
                size: "small",
                "aria-label": _unref(t)('Common.LoopConditionModePrompt'),
                onChange: onConditionModeChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElOption), {
                    value: "WHILE",
                    label: _unref(t)('Common.LoopConditionModeWhile')
                  }, null, 8, ["label"]),
                  _createVNode(_unref(ElOption), {
                    value: "DO_WHILE",
                    label: _unref(t)('Common.LoopConditionModeDoWhile')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model-value", "disabled", "aria-label"])
            ]))
          : _createCommentVNode("", true),
        (selectedLoopType.value !== 'FOR' && !isConditionalLoop.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("Common.LoopPropertyPrompt")), 1),
              _createElementVNode("input", {
                value: loopVariable.value,
                style: {"display":"none"},
                id: 'loopVariable-input-0',
                "data-id": 'loopVariable-input-0',
                class: "input form-control"
              }, null, 8, _hoisted_17),
              _createElementVNode("div", {
                class: "input-div loop-variable-input",
                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (hoveredField.value = 'loopVariable-input-0')),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (hoveredField.value = ''))
              }, [
                (hoveredField.value === 'loopVariable-input-0')
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: 
                recentlyCopied.value === 'loopVariable-input-0-div-'
                  ? 'check'
                  : 'copy'
              ,
                      class: "copy-icon",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (copyLoopContent()))
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  id: 'loopVariable-input-' + 0 + '-div-',
                  value: loopVariable.value,
                  contenteditable: "true",
                  class: "form-control root-div loop-variable-editor",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setFocusInput(0, 'loopVariable-input'))),
                  onBlur: onBlur,
                  onKeydown: onKeyDown,
                  onKeyup: organizeNodes,
                  onPasteCapture: _cache[3] || (_cache[3] = _withModifiers(
                (e) => pasteEvent(e, 0, 'loopVariable-input')
              , ["prevent"])),
                  spellcheck: "false"
                }, null, 40, _hoisted_18)
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (selectedLoopType.value === 'BATCH')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "left",
                content: _unref(t)('Common.BatchSizeTooltip')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("Common.BatchSize")), 1)
                ]),
                _: 1
              }, 8, ["content"]),
              _createVNode(_unref(ElInputNumber), {
                id: "batchSize-input",
                "data-id": "batchSize-input",
                "model-value": batchSizeInput.value,
                min: 1,
                step: 1,
                "step-strictly": "",
                class: "width-100",
                size: "small",
                disabled: _ctx.disabled,
                "aria-label": _unref(t)('Common.BatchSize'),
                "onUpdate:modelValue": onBatchSizeInput,
                onChange: onBatchSizeInput,
                onKeydown: onPositiveIntegerKeyDown,
                onPaste: onPositiveIntegerPaste
              }, null, 8, ["model-value", "disabled", "aria-label"])
            ]))
          : _createCommentVNode("", true),
        (selectedLoopType.value === 'FOR')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("label", {
                id: `${COUNT_INPUT_ID}-label`,
                class: "loop-desc",
                for: COUNT_DIV_ID
              }, _toDisplayString(_unref(t)("Common.Count")), 9, _hoisted_22),
              _createElementVNode("input", {
                value: count.value,
                style: {"display":"none"},
                id: 'count-input-0',
                "data-id": 'count-input-0',
                class: "input form-control"
              }, null, 8, _hoisted_23),
              _createElementVNode("div", {
                class: "input-div loop-variable-input",
                onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (hoveredField.value = 'count-input-0')),
                onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (hoveredField.value = ''))
              }, [
                (hoveredField.value === 'count-input-0')
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: recentlyCopied.value === 'count-input-0-div-' ? 'check' : 'copy',
                      class: "copy-icon",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (copyInputContent(COUNT_DIV_ID)))
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  id: COUNT_DIV_ID,
                  role: "textbox",
                  "aria-multiline": "true",
                  "aria-labelledby": `${COUNT_INPUT_ID}-label`,
                  value: count.value,
                  contenteditable: !_ctx.disabled,
                  class: "form-control root-div loop-variable-editor",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (setFocusInput(0, COUNT_INPUT_ID))),
                  onBlur: onBlur,
                  onKeydown: onKeyDown,
                  onKeyup: organizeNodes,
                  onPasteCapture: _cache[8] || (_cache[8] = _withModifiers((e) => pasteEvent(e, 0, COUNT_INPUT_ID), ["prevent"])),
                  spellcheck: "false"
                }, null, 40, _hoisted_24)
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (showParallelProcessingSettings.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    placement: "left",
                    content: _unref(t)('Common.ParallelJobsTooltip')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)("Common.ParallelProcessing")), 1)
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]),
                _createVNode(_unref(ElCheckbox), {
                  "model-value": parallelProcessing.value,
                  disabled: parallelProcessingCheckboxDisabled.value,
                  "aria-label": _unref(t)('Common.ParallelProcessing'),
                  onChange: onParallelProcessingChange
                }, null, 8, ["model-value", "disabled", "aria-label"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_unref(ElTooltip), {
                  effect: "custom",
                  placement: "left",
                  content: _unref(t)('Common.WorkersTooltip')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(t)("Common.ThreadCount")), 1)
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_unref(ElInputNumber), {
                  id: "threadCount-input",
                  "data-id": "threadCount-input",
                  "model-value": threadCountInput.value,
                  min: 1,
                  step: 1,
                  "step-strictly": "",
                  class: "width-100 loop-worker-control",
                  size: "small",
                  disabled: threadCountDisabled.value,
                  "aria-label": _unref(t)('Common.ThreadCount'),
                  "onUpdate:modelValue": onThreadCountInput,
                  onChange: onThreadCountInput,
                  onKeydown: onPositiveIntegerKeyDown,
                  onPaste: onPositiveIntegerPaste
                }, null, 8, ["model-value", "disabled", "aria-label"])
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createElementVNode("img", {
            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
            alt: _unref(t)('Common.Loading'),
            class: "loader-logo-40"
          }, null, 8, _hoisted_32)
        ], 512), [
          [_vShow, loading.value]
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#open-output-popup-dialog" }, [
      (dialogVisible.value)
        ? (_openBlock(), _createBlock(_unref(OutputDataDialog), {
            key: 0,
            dialog: dialogVisible.value,
            outputData: outputData.value,
            onClose: closeOutputDataDialog,
            title: `${_unref(getStepDisplayNumber)(_ctx.step.ix, _ctx.step.stepNumber)}. ${_unref(t)(
          'Flow.StepsOutputData'
        )}`,
            index: _ctx.step.ix + 1
          }, null, 8, ["dialog", "outputData", "title", "index"]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#proceed-step-popup-dialog" }, [
      (simulateDialogVisible.value)
        ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
            key: 0,
            dialog: simulateDialogVisible.value,
            selectedBuffer: selectedBuffer.value,
            moved: false,
            stoppable: true,
            "activity-id": activityId.value,
            "wizard-enabled": _ctx.wizardEnabled,
            onClose: closeSimulateDialog,
            onAnalyzeWithWizard: handleAnalyzeWithWizard
          }, null, 8, ["dialog", "selectedBuffer", "activity-id", "wizard-enabled"]))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_unref(FunctionSelector), {
      "output-list": outputDataList.value,
      "id-prefix": 'loop-' + 0,
      visible: functionSelectorVisible.value,
      mode: "input",
      "show-other-inputs": isCountInputFocused.value,
      showMeta: false,
      expressions: _ctx.expressions,
      "user-defined-variables": 
        isCountInputFocused.value ? _ctx.userDefinedVariables : undefined
      ,
      "disable-skipped-step-outputs": true,
      onAddOutput: addOutput,
      onAddUserVariable: addUserVariable,
      onAddFunction: addFunction
    }, null, 8, ["output-list", "visible", "show-other-inputs", "expressions", "user-defined-variables"])
  ]))
}
}

})